import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import '../../styles/RelatedBoats.css';
import BoatService from '../../services/BoatService';
import BoatCard from '../BoatsPage/BoatCard';

const RelatedBoats = ({ boat }) => {
  const [relatedBoats, setRelatedBoats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 700) {
        setSlidesToShow(1);
      } else if (window.innerWidth <= 1024) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial value on mount

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Reset slide to the beginning when the number of slides to show changes
    setCurrentSlide(0);
  }, [slidesToShow]);

  useEffect(() => {
    const loadRelatedBoats = async () => {
      if (!boat) {
        setRelatedBoats([]);
        setLoading(false);
        return;
      }

      try {
        const data = await BoatService.fetchRelatedBoats(boat.id);
        if (Array.isArray(data) && data.length > 0) {
          setRelatedBoats(data);
        } else {
          setRelatedBoats([]);
        }
      } catch (error) {
        setError('Failed to load related boats.');
      } finally {
        setLoading(false);
      }
    };

    loadRelatedBoats();
  }, [boat]);

  const maxSlides = relatedBoats.length > 0 ? Math.ceil(relatedBoats.length / slidesToShow) : 0;

  const nextSlide = () => {
    if (maxSlides === 0) return;
    setCurrentSlide(current => (current + 1) % maxSlides);
  };

  const prevSlide = () => {
    if (maxSlides === 0) return;
    setCurrentSlide(current => (current - 1 + maxSlides) % maxSlides);
  };

  const getVisibleBoats = () => {
    const startIndex = currentSlide * slidesToShow;
    return relatedBoats.slice(startIndex, startIndex + slidesToShow);
  };

  const showNavigation = relatedBoats.length > slidesToShow;

  return (
    <div className="related-boats-container">
      <div className="section-intro">
        <h2>Related Boats</h2>
      </div>

      <div className="related-boats-carousel">
        {loading ? (
          <p>Loading related boats...</p>
        ) : error ? (
          <p>{error}</p>
        ) : relatedBoats.length > 0 ? (
          <>
            <div className="related-boats-carousel__content">
              {showNavigation && (
                <button 
                  className="related-boats-carousel__arrow" 
                  onClick={prevSlide}
                  aria-label="Previous boats"
                >
                  <FontAwesomeIcon icon={faChevronLeft} className="related-boats-carousel__arrow-icon" />
                </button>
              )}
              
              <div className="related-boats-carousel__slides">
                {getVisibleBoats().map((relatedBoat) => (
                  <div key={relatedBoat.id} className="related-boats-carousel__slide">
                    <BoatCard boat={relatedBoat} />
                  </div>
                ))}
              </div>

              {showNavigation && (
                <button 
                  className="related-boats-carousel__arrow" 
                  onClick={nextSlide}
                  aria-label="Next boats"
                >
                  <FontAwesomeIcon icon={faChevronRight} className="related-boats-carousel__arrow-icon" />
                </button>
              )}
            </div>
          </>
        ) : (
          <p>No related boats available.</p>
        )}
      </div>
    </div>
  );
};

export default RelatedBoats; 